import { useState, useEffect, Fragment, useCallback } from 'react';
import { Modal, ModalBody } from 'react-bootstrap';
import { ResponseSuccessModal, ResponseFailModal } from '../../components/Modal/Response';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../stores';
import BlackDelete from '../../components/BlackList/BlackDelete';
import { changeResult, deleteBlackListAction, initialize } from '../../stores/blackList';
import { BlackDeleteContainerProps } from '../../types/blackList';

const BlackDeleteContainer = ({
  isOpen,
  toggle,
  reload,
  id,
  blackListName,
}:BlackDeleteContainerProps) => {
  const dispatch = useDispatch();
  const { blackDeleteSuccess, blackDeleteError } = useSelector(({ blackList }:RootState) => ({
      blackDeleteSuccess: blackList.blackDeleteSuccess,
      blackDeleteError: blackList.blackDeleteError,
  }));
  const [ isOpenBlackListDeleteSuccessModal, setIsOpenBlackListDeleteSuccessModal ] = useState<boolean>(false);
  const [ isOpenBlackListDeleteFailModal, setIsOpenBlackListDeleteFailModal ] = useState<boolean>(false);
  const [ messageBlackListDeleteFail, setMessageBlackListDeleteFail ] = useState<string>('');

  const handleDeleteHotel = useCallback(() => {
    dispatch(deleteBlackListAction({id}));
  },[id, dispatch]);


  useEffect(() => {
    if(blackDeleteError){
      toggle();
      if (!blackDeleteError.response){
        setMessageBlackListDeleteFail(blackDeleteError.message);
        setIsOpenBlackListDeleteFailModal(true);
      }else{
        if (blackDeleteError.response.data === undefined){
          setMessageBlackListDeleteFail(blackDeleteError.message);
        }else{
          setMessageBlackListDeleteFail(`${blackDeleteError.response.data.code}, ${blackDeleteError.response.data.message}`);
          if(blackDeleteError.response.data?.code === 401 || blackDeleteError.response.data?.code === 419) reload();
        }
        setIsOpenBlackListDeleteFailModal(true);
      }
      dispatch(changeResult({
        key: 'blackDeleteError',
        value: null,
      }));
      return;
    }
    if(blackDeleteSuccess){
      toggle();
      setIsOpenBlackListDeleteSuccessModal(true);
      setTimeout(() => {
        setIsOpenBlackListDeleteSuccessModal(false);
        reload();
      }, 1500);
      dispatch(initialize()); //hotel.ts 전역상태 초기화
    }
  },[dispatch, blackDeleteError, blackDeleteSuccess, reload, toggle]);
  
  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        size='sm'
      >
        <ModalBody className='text-center m-3'>
          <BlackDelete 
            blackListName={blackListName}
            toggle={toggle}
            handleDeleteHotel={handleDeleteHotel}
          />
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenBlackListDeleteSuccessModal}
        toggle={() => setIsOpenBlackListDeleteSuccessModal(!isOpenBlackListDeleteSuccessModal)}
        message='객실 삭제가 완료 되었습니다.'
      />
      <ResponseFailModal
        isOpen={isOpenBlackListDeleteFailModal}
        toggle={() => setIsOpenBlackListDeleteFailModal(!isOpenBlackListDeleteFailModal)}
        message={messageBlackListDeleteFail || '객실 삭제에 실패 하였습니다.'}
      />
    </Fragment>
  );
};

export default BlackDeleteContainer;